<template>
  <div style="height: 100%">
    <div id="app">
      <div class="wrapper">
        <router-view/>

        <div id="addToHomeContainer">
          <div class="a2hs-title">
            Adicionar a Tela Inicial
          </div>
          <div class="a2hs-logo"></div>
          <div class="a2hs-text">            
            Quero Créditos
          </div>
          <div class="a2hs-btn">
            <div id="a2hs-btn-cancel">Cancelar</div>
            <div id="a2hs-btn-add">Adicionar</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import localforage from 'localforage'
  import axios from 'axios'
  export default {
    sockets: {
      connect: function () {

        if (this.usuarioLogado) {
          this.getTransacoes()
        }
      },
      updateUserList: function (users) {
 
        users.forEach((u) => {
          let index = this.usersList.indexOf(u)
          if (index === -1) {
            this.usersList.push(u)
          }
        })
      },
      newMessageServer: function (messageData) {
 
        messageData.idUsuario = messageData.fromId
        messageData.fkUsuarioLogin = messageData.fromUsername
        messageData.fkUsuarioNome = messageData.fromName
        messageData.usersList = this.usersList
        messageData.username = this.usuarioLogado.sub
        messageData.mensagem = messageData.message
        //messageData.transacaoStatus = messageData.transacaoStatus

        delete messageData.transacaoStatus;
        
        // tela a ser apresentada
        if (this.isAdministrador) {
          messageData.route = 'transacoesCompraVenda.index'
        } else {
          messageData.route = 'historico.index'
        }
        // lado da mensagem
        if (messageData.fromUsername !== this.usuarioLogado.sub) {
          messageData.side = 'left'
        } else {
          messageData.side = 'right'
        }
  
       // this.$bus.$emit('newMessageToChatList', messageData)
       // this.$bus.$emit('newMessageToChat', messageData)

      },
      newMessageCount: function (message) {
 
         this.$bus.$emit('newMessageToChatList', message)

      },
      newMessage: function (message) {

        if (message.usuario) {
          if (message.from) {
            if (message.from !== this.usuarioLogado.sub) {
              this.chats.room = message.room
              this.chats.username = this.usuarioLogado.sub
              this.chats.mensagem = message.text
              this.chats.timenow = message.timenow
              this.chats.side = 'left'
              this.chats.idTransacaoCompraVenda = message.idTransacaoCompraVenda
              this.chats.idUsuario = message.usuario.id
              this.chats.fkUsuarioLogin = message.usuario.login
              this.chats.fkUsuarioNome = message.usuario.nome
              this.chats.color = 'white'
              this.chats.colorUsed = '#d8f1e4'

  
              if (this.isAdministrador) {
                this.chats.route = 'transacoesCompraVenda.index'
              } else {
                this.chats.route = 'historico.index'
              }
              const verb = 'post'

              var chatsData = this.chats
              delete  chatsData.transacaoStatus;
              delete  chatsData.html;
              delete  chatsData.text;

              var chats = Object.assign({}, chatsData)

             this.save({verb, chats}).then(() => {

                message.usersList = this.usersList
                
                var messageToChat = this.chats
                messageToChat.transacaoStatus = message.transacaoStatus;
                messageToChat.html = message.html;
 
                this.$bus.$emit('newMessageToChat', chats)

              })
 
 
            }
          }
        }
      },
      newAction: function (action) {
        if (typeof action === 'string') {
          try {
            action = JSON.parse(action)
          } catch (error) {
            console.error(error)
          }
        }
        if (action.description === 'saleChips' || action.description === 'buyChips') {
          this.$bus.$emit('newTransaction', action)
        } else if (action.description === 'updateStatusTransaction') {
          this.$bus.$emit('updateStatus', action)
        } else if (action.description === 'selfieVerified') {
          this.$bus.$emit('selfieVerified', action)
        }
      },
      userLeft: function (data) {
        if (this.$route.name === 'historico.index' || this.$route.name === 'transacoesCompraVenda.index') {
          this.$bus.$emit('userDisconnect', data)
        }
        this.socketId = ''
      },
      disconnect: function () {
      }
    },
    data () {
      return {
        socketId: '',
        room: '',
        usuario: {},
        usersList: [],
        chats: {
          id: 0,
          room: '',
          username: '',
          mensagem: '',
          timenow: '',
          side: '',
          idTransacaoCompraVenda: 0,
          idUsuario: 0,
          fkUsuarioLogin: '',
          fkUsuarioNome: ''
        }
      }
    },
    watch: {
      '$route' () {
        if (this.usuarioLogado) {
          this.getTransacoes()
        }
      }
    },
    methods: {
      ...mapActions('transacoesCompraVenda', ['updateCountMessages']),
      ...mapActions(['toast']),
      ...mapActions(['setIpClient']),
      ...mapActions('chats', ['save']),
      async getTransacoes () {
        if (this.usuarioLogado) {

          var tipo = 'arquivadas'
          var usuario = this.getUsuario;
          var usuarioLogado = this.usuarioLogado.sub;
          var pagina = 1
          var quantidadePorPagina = 10
          var storageItens = await localforage.getItem('unreadMessagesArquivadas')

          // if(this.$route.name === 'transacoesCompraVendaArquivadas.index') {
          //    await this.fetchMaisAntigas({ tipo, pagina, quantidadePorPagina, storageItens, usuario, usuarioLogado  })
          // }
          // else {
          //    await this.fetch()
          // }
 
          await this.insertUserInChat()
          await this.insertUserCountInChat()
        }
      },
      async insertUserCountInChat () {

        if(this.isAdministrador){
 
         let params = {}
         params.username = this.usuarioLogado.sub
         params.room = 'chat_count'
         params.usuario = this.getUsuario
         params.idTransacao = ''
         params.transacaoStatus =  ''
         

         this.$socket.emit('join', params, function (err) {
           if (err) {
             console.error(err)
           }
         })

       }
       
      },
      async insertUserInChat () {

        if (this.hasListTransacoes) {
          this.listTransacoes.forEach((t) => {

            let joinUser = {}
            let params = {}
            let tr = t
            // 4 finalizada 5 cancelada 8 aprovada
            if (t.transacaoStatus !== 4 && t.transacaoStatus !== 5) {
              if (this.isAdministrador) {
                // console.log('insert admin in chat')
                params = {}
                params.username = this.usuarioLogado.sub
                params.room = 'chat_' + tr.id
                params.usuario = this.getUsuario
                params.idTransacao = tr.id
                params.transacaoStatus = tr.transacaoStatus
                joinUser.chat = 'chat_' + t.id
                this.$socket.emit('addUserInChatTransactionBuyAndSell', joinUser)
                this.$socket.emit('join', params, function (err) {
                  if (err) {
                    console.error(err)
                  }
                })
              } else {


                const usuarioLogado = String(this.usuarioLogado.sub)
                const usuarioChat = String(tr.usuario.login)
                
                  params = {}
                  params.username = this.usuarioLogado.sub
                  params.room = 'chat_' + tr.id
                  params.usuario = this.getUsuario
                  params.idTransacao = tr.id
                  params.transacaoStatus = tr.transacaoStatus
  
                  this.$socket.emit('join', params, function (err) {
                    if (err) {
                      console.error(err)
                    }
                  })

 
              }
            }
          })
        }
      },
       async insertUserInChatWithList (listTransacoes) {

         alert('ITEN CALLED')

            listTransacoes.forEach((t) => {

            console.log('chat_' + t.id)

            let joinUser = {}
            let params = {}
            let tr = t
            // 4 finalizada 5 cancelada 8 aprovada
            console.log('this+   '+ t.transacaoStatus )
            if (t.transacaoStatus !== 4 && t.transacaoStatus !== 5) {
              if (this.isAdministrador) {
                // console.log('insert admin in chat')
                params = {}
                params.username = this.usuarioLogado.sub
                params.room = 'chat_' + tr.id
                params.usuario = this.getUsuario
                params.idTransacao = tr.id
                params.transacaoStatus = tr.transacaoStatus
                joinUser.chat = 'chat_' + t.id
                this.$socket.emit('addUserInChatTransactionBuyAndSell', joinUser)
                this.$socket.emit('join', params, function (err) {
                  if (err) {
                    console.error(err)
                  }
                })
              } else {

                const usuarioLogado = String(this.usuarioLogado.sub)
                const usuarioChat = String(tr.usuario.login)
                
                  if (usuarioChat === usuarioLogado) {

                         params = {}
                         params.username = this.usuarioLogado.sub
                         params.room = 'chat_' + tr.id
                         params.usuario = this.getUsuario
                         params.idTransacao = tr.id
                         params.transacaoStatus = tr.transacaoStatus
       
                         this.$socket.emit('join', params, function (err) {
                           if (err) {
                             console.error(err)
                           }
                         })

                  }
              }
            }
          })
      },
      async discoveryIpClient () {
        let instance = axios.create({
          baseURL: 'https://ipapi.co/',
          timeout: 3000
        })
        try {
          const response = await instance.get('json')
          if (response.status === 200) {
            this.setIpClient(response.data)
          } else {
            throw new Error('Error set ip client')
          }
        } catch (e) {
          console.error('ip-error', e)
        }
      }
    },
    computed: {
      ...mapGetters('auth', ['getUsuario']),
      ...mapGetters(['usuarioLogado', 'isAdministrator']),
      ...mapState('transacoesCompraVenda', {
        listTransacoes (state) {
          return state.list
        },
        // listTransacoesArquivadas (state) {
        //   return state.list
        // }
      }),
      ...mapGetters(['getIpClient']),
      isAdministrador () {
        return this.usuarioLogado.role === 'admin'
      },
      rotaOut () {
        return this.$route.name !== 'historico.index' || this.$route.name !== 'transacoesCompraVenda.index'
      },
      hasListTransacoes () {
        return this.listTransacoes !== undefined && this.listTransacoes.length > 0
      }
    },
    mounted () {
      if (this.usuarioLogado) {
        this.getTransacoes()
      }
      this.discoveryIpClient()
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">

  html, body, #app, .wrapper {
    height: 100%;
  }
  .fixo-wrapper {
    width: 98% !important;
    overflow: hidden !important;
  }
  .rolavel-wrapper {
    width: 100% !important;
    overflow-y: scroll !important;
  }

  #addToHomeContainer {
    display: none;
    grid-template-rows: 40px 100px 50px;
    grid-template-columns: 100px 1fr;
    grid-template-areas:
      "a2hs-title a2hs-title"
      "a2hs-logo a2hs-text"
      "a2hs-btn a2hs-btn";

    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fefefe;
    height: 200px;
    border: 1px solid #dfdfdf;
    box-shadow: 2px 2px 13px 0px rgba(0, 69, 126, 1);
    z-index: 99999999;

    @media screen and (min-width: 768px) {
      display: none !important;
    }

    & .a2hs-title{
      grid-area: a2hs-title;
      display: flex;
      align-items: center;
      padding-left: 20px;
      font-size: 1.2rem;
      font-weight: bolder;
    }
    .a2hs-logo {
      grid-area: a2hs-logo;
      margin-left: 20px;
      background-image: url("/static/img/logo-color.png?v3");
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    .a2hs-text {
      grid-area: a2hs-text;
      display: flex;
      align-items: center;
      font-size: 1.5rem;
    }
    .a2hs-btn {
      grid-area: a2hs-btn;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 20px;
    }

    #a2hs-btn-cancel {
      padding: 5px 8px;
      font-weight: bolder;
      color: #00a9ff;
      cursor: pointer;
      font-size: 1.2rem;
      margin-right: 20px;

      &:hover {
        background-color: #25765C;
      }
    }

    #a2hs-btn-add {
      padding: 5px 8px;
      font-weight: bolder;
      color: #00a9ff;
      cursor: pointer;
      font-size: 1.2rem;

      &:hover {
        background-color: #25765C;
      }
    }

  }


</style>
<style lang="sass" src="./assets/sass/app.scss?1"></style>



// WEBPACK FOOTER //
// the-container.vue?4d61e4c0